import { render, staticRenderFns } from "./AssetTreeMenu.vue?vue&type=template&id=4e1ebc84&scoped=true"
import script from "./AssetTreeMenu.vue?vue&type=script&lang=js"
export * from "./AssetTreeMenu.vue?vue&type=script&lang=js"
import style0 from "./AssetTreeMenu.vue?vue&type=style&index=0&id=4e1ebc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ebc84",
  null
  
)

export default component.exports